export enum CustomOptionsEnum {
  All = 0,
  OrderService = 1,
  OrderProduct = 2,
  OrderEquipment = 3,
  OrderSchedule = 4,
}
